import React from "react"
import Spinner from "react-bootstrap/Spinner"

import styles from "./loading-overlay.module.scss"

interface LoadingOverlayProps {
    isLoading: boolean
}

export const LoadingOverlay: React.FunctionComponent<LoadingOverlayProps> = ({
    isLoading,
    children,
}) => {
    if (!isLoading) {
        return null
    }

    return (
        <div className={styles.overlay}>
            <Spinner animation="border" role="status" />
            {children}
        </div>
    )
}
